import React, { useContext, useState } from 'react'
import styles from "./authentication.module.css";
import Button from '../button';
import FormInput from "../input"
import logo from "../../assets/header_logo.png";
import { notify } from '../toast';
import { Auth_Login } from '../../utils/authentication';
import { AuthContext } from '../../contextAPI';

const Authentication = (props) => {
    const User = useContext(AuthContext)
    const [isLoading, setIsLoading] = useState(false)
    const [emailValue, setEmailValue ] = useState("")
    const [passwordValue, setPasswordValue] = useState("")

    const changeEmailHandler = (text) => {
        setEmailValue(text.target.value)
    }

    const changePasswordHandler = (text) => {
        setPasswordValue(text.target.value)
    }


    const onLoginHandler = async() => {
        try {
            setIsLoading(true);
            
            const responseData = await Auth_Login(
                {
                    email: emailValue,
                    password: passwordValue
                },
            )

        
            if(!responseData.status){
            throw new Error(responseData.message)
            }
    
            // notify(responseData.message, "success")
            User.login(responseData);
            props.onSubmit()

        } catch (error) {
            setIsLoading(false)

            notify(error.message || "Neteisingi prisijungimo duomenys","error")
        }
    }

    const onLogoutHandler = () => {
        User.logout()
        return props.onSubmit()
    }

    return (
        <div className={styles.container}>

            {
                User.isLoggedIn && User.authenticatedUser && !isLoading ? 
                <Button onClick={onLogoutHandler}>Atsijungti</Button>
                :
                <>
                    <div className={styles.inputbox}>
                        <input onChange={changeEmailHandler} value={emailValue} required="required" type="text" />
                        <span>El. paštas</span>
                        <i></i>
                    </div>
                    <div className={styles.inputbox}>
                        <input onChange={changePasswordHandler} value={passwordValue} required="required" type="password" />
                        <span>Slaptažodis</span>
                        <i></i>
                    </div>
                    <Button onClick={onLoginHandler}>{isLoading ? "Loading" : "Prisijungti"}</Button>
                </>
            }

        </div>
    )
}

export default Authentication